export default "__VITE_ASSET__bNjxTTos__"